@if (apiUrl) {
  <div class="api-url">{{ apiUrl }}</div>
}

@if (branding$ | async; as branding) {
  <div class="header" [class.resolving]="branding.isResolving">
    @if (!branding.isResolving) {
      <app-logo
        [providerLogo]="branding.isWhiteLabel ? branding.headerImage : ''"
        [providerTitle]="branding.isWhiteLabel ? branding.providerTitle : ''">
      </app-logo>
    }
  </div>
}
